import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import classList from 'flarum/common/utils/classList';
import extractText from 'flarum/common/utils/extractText';
export default class ClassifiedsLandingPage extends Page {
  loading = true;
  classifiedsTags = [];
  oninit(vnode) {
    super.oninit(vnode);
    this.bodyClass = 'App--index ClassifiedsLandingPage-body';
    app.setTitle(extractText(app.translator.trans('flarum-classifieds.forum.landing.title')));
    this.loadTags();
  }
  loadTags() {
    this.loading = true;
    app.store.find('tags', {
      include: 'parent'
    }).then(tags => {
      this.classifiedsTags = (tags || []).filter(t => t && typeof t.isClassifieds === 'function' && t.isClassifieds());
      this.loading = false;
      m.redraw();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
  view() {
    const user = app.session.user;
    const greeting = user ? app.translator.trans('flarum-classifieds.forum.landing.greeting', {
      username: user.displayName?.() || user.username?.()
    }) : app.translator.trans('flarum-classifieds.forum.landing.greeting_guest');
    return m("div", {
      className: "ClassifiedsLanding"
    }, m("header", {
      className: "ClassifiedsLanding-header"
    }, m("span", {
      className: "ClassifiedsLanding-greeting"
    }, greeting), m("span", {
      className: "ClassifiedsLanding-prompt"
    }, app.translator.trans('flarum-classifieds.forum.landing.prompt'))), this.loading ? m(LoadingIndicator, null) : this.classifiedsTags.length === 0 ? m("p", {
      className: "ClassifiedsLanding-empty"
    }, app.translator.trans('flarum-classifieds.forum.landing.empty')) : m("div", {
      className: "ClassifiedsLanding-grid"
    }, this.classifiedsTags.map((tag, idx) => this.renderCategoryCard(tag, idx))));
  }
  renderCategoryCard(tag, idx) {
    const color = tag.color() || 'var(--primary-color)';
    const icon = tag.icon() || 'fas fa-tag';
    const slug = tag.slug();
    const count = typeof tag.discussionCount === 'function' ? tag.discussionCount() : 0;
    return m("a", {
      key: String(tag.id()),
      className: classList('ClassifiedsLanding-card', `ClassifiedsLanding-card--${idx}`),
      style: {
        '--tag-color': color
      },
      href: app.route('tag', {
        tags: slug
      }),
      config: m.route.link,
      "aria-label": extractText(app.translator.trans('flarum-classifieds.forum.landing.select_category', {
        name: tag.name()
      }))
    }, m("div", {
      className: "ClassifiedsLanding-cardIcon",
      "aria-hidden": "true"
    }, m("i", {
      className: icon
    })), m("div", {
      className: "ClassifiedsLanding-cardBody"
    }, m("span", {
      className: "ClassifiedsLanding-cardTitle"
    }, tag.name()), tag.description() ? m("span", {
      className: "ClassifiedsLanding-cardSubtitle"
    }, tag.description()) : count ? m("span", {
      className: "ClassifiedsLanding-cardSubtitle"
    }, app.translator.trans('flarum-classifieds.forum.landing.discussion_count', {
      count
    })) : null));
  }
}
flarum.reg.add('ramon-classifieds', 'forum/components/ClassifiedsLandingPage', ClassifiedsLandingPage);